// errorhead-definitions.js — Parameter definitions for errorhead GLSL effects.
//
// Ported from eg0pr0xy/errorhead (services/glitchEngine/webgl/shaders.ts,
// destruction.ts, post.ts). Each definition maps to a shader in
// errorhead-shaders.js and describes the user-facing parameters.
//
// Param types:
//   range    — float slider (min, max, step, defaultValue)
//   checkbox — 0/1 toggle
//   select   — dropdown (options: [{label, value}])

var EFFECT_DEFINITIONS = [
    // ---- 1. MOSH — Motion sculpture ----
    {
        id: 'mosh',
        name: 'Mosh',
        params: [
            { key: 'flowAmp',      label: 'Flow Amp',       type: 'range', min: 0,    max: 0.05, step: 0.001, defaultValue: 0.01 },
            { key: 'flowScale',    label: 'Flow Scale',     type: 'range', min: 0.5,  max: 10,   step: 0.1,   defaultValue: 2.0 },
            { key: 'flowSpeed',    label: 'Flow Speed',     type: 'range', min: 0,    max: 5,    step: 0.1,   defaultValue: 1.0 },
            { key: 'driftX',       label: 'Drift X',        type: 'range', min: -0.5, max: 0.5,  step: 0.01,  defaultValue: 0.0 },
            { key: 'driftY',       label: 'Drift Y',        type: 'range', min: -0.5, max: 0.5,  step: 0.01,  defaultValue: 0.0 },
            { key: 'globalRot',    label: 'Rotation',       type: 'range', min: -3.14,max: 3.14, step: 0.05,  defaultValue: 0.0 },
            { key: 'globalZoom',   label: 'Zoom',           type: 'range', min: -50,  max: 50,   step: 1,     defaultValue: 0 },
            { key: 'diffusion',    label: 'Diffusion',      type: 'range', min: 0,    max: 10,   step: 0.5,   defaultValue: 0 },
            { key: 'persistence',  label: 'Persistence',    type: 'range', min: 0,    max: 1,    step: 0.01,  defaultValue: 0.8 },
            { key: 'injection',    label: 'Injection',      type: 'range', min: 0,    max: 1,    step: 0.01,  defaultValue: 0.2 },
            { key: 'sculptThreshold', label: 'Sculpt Thresh', type: 'range', min: 0, max: 1,   step: 0.01,  defaultValue: 0.5 },
            { key: 'sculptSoftness',  label: 'Sculpt Soft',   type: 'range', min: 0, max: 0.5, step: 0.01,  defaultValue: 0.2 }
        ]
    },
    // ---- 2. POST — Post-processing ----
    {
        id: 'post',
        name: 'Post',
        params: [
            { key: 'chroma',    label: 'Chroma',    type: 'range', min: 0,   max: 0.05, step: 0.001, defaultValue: 0.005 },
            { key: 'grain',     label: 'Grain',     type: 'range', min: 0,   max: 0.5,  step: 0.01,  defaultValue: 0.08 },
            { key: 'vignette',  label: 'Vignette',  type: 'range', min: 0,   max: 3,    step: 0.1,   defaultValue: 1.2 },
            { key: 'contrast',  label: 'Contrast',  type: 'range', min: 0.5, max: 2,    step: 0.05,  defaultValue: 1.1 }
        ]
    },
    // ---- 3. MELT — Vertical strip dropping ----
    {
        id: 'melt',
        name: 'Melt',
        params: [
            { key: 'intensity',  label: 'Intensity',  type: 'range', min: 0,    max: 1,    step: 0.01,  defaultValue: 0.5 },
            { key: 'stripWidth', label: 'Strip Width',type: 'range', min: 2,    max: 50,   step: 1,     defaultValue: 10 },
            { key: 'burn',       label: 'Burn',       type: 'range', min: 0,    max: 1,    step: 0.01,  defaultValue: 0.0 },
            { key: 'warp',       label: 'Warp',       type: 'range', min: 0,    max: 1,    step: 0.01,  defaultValue: 0.3 }
        ]
    },
    // ---- 4. SHRED — Horizontal slice displacement ----
    {
        id: 'shred',
        name: 'Shred',
        params: [
            { key: 'intensity',   label: 'Intensity',   type: 'range', min: 0,   max: 1,  step: 0.01,  defaultValue: 0.5 },
            { key: 'sliceHeight', label: 'Slice Height',type: 'range', min: 2,   max: 80, step: 1,     defaultValue: 20 },
            { key: 'warp',        label: 'Warp',        type: 'range', min: 0,   max: 2,  step: 0.01,  defaultValue: 1.0 }
        ]
    },
    // ---- 5. SCATTER — Random chunk displacement ----
    {
        id: 'scatter',
        name: 'Scatter',
        params: [
            { key: 'intensity',  label: 'Intensity',  type: 'range', min: 0,   max: 1,  step: 0.01,  defaultValue: 0.5 },
            { key: 'chunkCount', label: 'Chunk Count',type: 'range', min: 5,   max: 40, step: 1,     defaultValue: 20 },
            { key: 'blend',      label: 'Blend',      type: 'range', min: 0,   max: 1,  step: 0.01,  defaultValue: 0.3 },
            { key: 'scale',      label: 'Scale Var',  type: 'range', min: 0,   max: 1,  step: 0.01,  defaultValue: 0.2 }
        ]
    },
    // ---- 6. SCANLINES — CRT scanline overlay ----
    {
        id: 'scanlines',
        name: 'Scanlines',
        params: [
            { key: 'spacing',   label: 'Spacing',   type: 'range', min: 1,   max: 12, step: 0.5, defaultValue: 4 },
            { key: 'intensity', label: 'Intensity', type: 'range', min: 0,   max: 1,  step: 0.01, defaultValue: 0.5 },
            { key: 'shimmer',   label: 'Shimmer',   type: 'range', min: 0,   max: 1,  step: 0.01, defaultValue: 0.2 }
        ]
    },
    // ---- 7. BURN — Heat tint overlay ----
    {
        id: 'burn',
        name: 'Burn',
        params: [
            { key: 'intensity', label: 'Intensity', type: 'range', min: 0,   max: 1,  step: 0.01, defaultValue: 0.5 },
            { key: 'tint',      label: 'Tint',      type: 'range', min: 0,   max: 1,  step: 0.01, defaultValue: 0.0 },
            { key: 'blend',     label: 'Hard Light',type: 'range', min: 0,   max: 1,  step: 0.01, defaultValue: 0.5 }
        ]
    },
    // ---- 8. RGB-SPLIT — RGB channel separation ----
    {
        id: 'rgb-split',
        name: 'RGB Split',
        params: [
            { key: 'redShift',    label: 'Red Shift',    type: 'range', min: -0.1, max: 0.1, step: 0.001, defaultValue: 0.005 },
            { key: 'greenShift',  label: 'Green Shift',  type: 'range', min: -0.1, max: 0.1, step: 0.001, defaultValue: 0.0 },
            { key: 'blueShift',   label: 'Blue Shift',   type: 'range', min: -0.1, max: 0.1, step: 0.001, defaultValue: -0.005 },
            { key: 'globalShift', label: 'Global Shift', type: 'range', min: 0,    max: 0.1, step: 0.001, defaultValue: 0.0 },
            { key: 'angle',       label: 'Angle',        type: 'range', min: 0,    max: 1,   step: 0.05,  defaultValue: 0.0 }
        ]
    }
];

module.exports = {
    EFFECT_DEFINITIONS
};
